import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { SUPPORT_USER, SUPPORT_SESSION, inSupportMode } from '@app/lib/remote-login';
import { Pusher } from './pusher';

const URL_TRACKING_PING_INTERVAL = 1000;

@Injectable({
  providedIn: 'root',
})
export class SupportModeService {
  private channel;
  private _trackingStatus = 'disconnected';
  private trackingSubscription;
  private trackingPingInterval;

  constructor(@Inject(Pusher) pusher, private router: Router) {
    this.channel = pusher.getUserChannel('hijack');
    if (!this.inSupportMode) this.initNormalSession();
  }

  get trackingStatus() {
    return this._trackingStatus;
  }

  get inSupportMode() {
    return inSupportMode();
  }

  get supportUser() {
    return SUPPORT_USER;
  }

  get supportSession() {
    return SUPPORT_SESSION;
  }

  public startTracking() {
    this._trackingStatus = 'connecting';
    this.subHijackTracking();
    // Keep pinging client until the first tracking message is receieved
    const ping = (attempt = 1) => {
      if (attempt <= 5) {
        this.channel.broadcast('hijack-track-start');
        this.trackingPingInterval = setTimeout(() => ping(attempt + 1), URL_TRACKING_PING_INTERVAL);
      } else {
        this._trackingStatus = 'disconnected';
        this.trackingPingInterval = 0;
        this.unSubHijackTracking();
      }
    };
    ping(); // Initial broadcast
  }

  public stopTracking() {
    this._trackingStatus = 'disconnected';
    this.unSubHijackTracking();
    this.clearTrackingPing();
  }

  public sendCurrentUrl() {
    this.channel.broadcast('hijack-track', { url: this.router.url });
  }

  private clearTrackingPing() {
    if (this.trackingPingInterval) {
      clearTimeout(this.trackingPingInterval);
      this.trackingPingInterval = 0;
    }
  }

  private unSubHijackTracking() {
    if (this.trackingSubscription) this.trackingSubscription.unsubscribe();
  }

  private subHijackTracking() {
    this.trackingSubscription = this.channel.getClientEvent('hijack-track').subscribe(data => {
      if (this.trackingStatus !== 'disconnected') {
        this._trackingStatus = 'connected';
        this.router.navigateByUrl(data.url);
        this.clearTrackingPing();
      }
    });
  }

  private initNormalSession() {
    this.channel.getClientEvent('hijack-track-start').subscribe(event => {
      this._subscribeToRouterEvents();
      this.sendCurrentUrl(); // Initial route
    });
  }

  private _subscribeToRouterEvents() {
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        this.sendCurrentUrl();
      }
    });
  }

}
